import './styles.scss'
import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import LayoutContainer from 'Components/LayoutComponent'
import { ROUTE_STRINGS } from 'Utils/Constants'

const CoffeeCommunity = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const adminPanelItems = [
    {
      id: 1,
      icon: 'pi pi-user',
      title: 'Users',
      description: 'Manage user accounts and settings',
      link: ROUTE_STRINGS.userManagement
    },
    {
      id: 2,
      icon: 'pi pi-users',
      title: 'Communities',
      description: 'Manage public communities',
      link: ROUTE_STRINGS.communityManagement
    },
    {
      id: 3,
      icon: 'pi pi-shield',
      title: 'Internal Communities Admin',
      description: 'Manage internal communities',
      link: ROUTE_STRINGS.internalCommunitiesManagement
    },
    {
      id: 4,
      icon: 'pi pi-list',
      title: 'Report Reasons',
      description: 'Manage report reason categories'
    },
    {
      id: 5,
      icon: 'pi pi-ban',
      title: 'Blocked Users',
      description: 'View and manage blocked users'
    },

    {
      id: 6,
      icon: 'pi pi-exclamation-circle',
      title: 'Report Abuse',
      description: 'Review and handle abuse reports'
    }
  ]

  const handleCommunityClick = (url) => {
    history.push(url)
  }

  return (
    <LayoutContainer title={t('COFFEE_COMMUNITY')} breadCrumbsTitle={'coffeeCommunity'}>
      <div className="coffee-community-container">
        {adminPanelItems?.map((item) => (
          <div key={item.id} className={`community-card ${!item.link ? 'disabled' : ''}`} onClick={() => item?.link && handleCommunityClick(item?.link)}>
            <div className="card-icon">
              <i className={`${item?.icon} community-icon`} />
            </div>
            <div className="card-content">
              <h3 className="card-title">{item?.title}</h3>
              <p className="card-description">{item?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </LayoutContainer>
  )
}

export default CoffeeCommunity
